import type { IntegrationsSyncRunFragment } from 'generated/resources/graphql'

export const SyncRunStatus = {
  SUCCEEDED: 'succeeded',
  RUNNING: 'running',
  ERRORED: 'errored',
  SUCCEEDED_WITH_ERRORS: 'succededwitherrors',
} as const

export type SyncRunStatusTypes = (typeof SyncRunStatus)[keyof typeof SyncRunStatus]

export const isSyncRunRunning = (syncRun: IntegrationsSyncRunFragment | undefined): boolean =>
  syncRun?.status === SyncRunStatus.RUNNING

export const INTEGRATIONS_SYNC_RUN_STATUS_ID_PREFIX = 'syncRunStatusId'

export const setSyncRunStatusIdSessionStorage = (syncRunId: string) => {
  sessionStorage.setItem(`${INTEGRATIONS_SYNC_RUN_STATUS_ID_PREFIX}-${syncRunId}`, syncRunId)
}

export const getSyncRunStatusIdSessionStorage = (syncRunId: string) => {
  return sessionStorage.getItem(`${INTEGRATIONS_SYNC_RUN_STATUS_ID_PREFIX}-${syncRunId}`)
}
